import './ExportDataForm.scss';
import { useTranslator } from '@Localization';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { toLocaleDateTimeString } from '../../../../../../__legacy__/helpers/date.helpers';
import { Select } from '../../../../../../design/inputs/select/Select';
import { RowLayout } from '../../../../../common/layouts/rowLayout/RowLayout';
import { ExportDataFilter } from '../../models/ExportDataFilter';
import { ExportButtonContainer } from '../button/ExportButton.container';

interface IProps {
  selectedFilter: ExportDataFilter;
  onChangeDataRange: (dataRange: ExportDataFilter) => void;
  annotationsLastModifiedDate: string;
}

export const ExportDataForm = observer((props: IProps): ReactElement => {
  const { t } = useTranslator();
  const { onChangeDataRange, annotationsLastModifiedDate } = props;

  const options = [
    { value: ExportDataFilter.ALL, label: t('new.projects.details.export_data.everything') },
    { value: ExportDataFilter.ACCEPTED, label: t('new.projects.details.export_data.all_accepted_data') },
    { value: ExportDataFilter.ANNOTATED, label: t('new.projects.details.export_data.all_annotated_data') },
    { value: ExportDataFilter.CONFIG_ONLY, label: t('new.projects.details.export_data.project_configuration_only') },
  ];

  return (
    <div className='export-data-form'>
      <strong className='last-modified-date'>
        {t('new.projects.details.export_data.annotations_last_modified_date', {
          annotationsLastModifiedDate: toLocaleDateTimeString(annotationsLastModifiedDate),
        })}
      </strong>
      <RowLayout
        className='export-data-selector'
        size='sm'
      >
        <Select
          id='data-range-select'
          value={options.find((x) => x.value === props.selectedFilter)}
          onChange={(_, v) => {
            onChangeDataRange(v.value);
          }}
          options={options}
        />
        <ExportButtonContainer />
      </RowLayout>
      <div className='json-documentation-link'>
        <p>
          {t('new.projects.details.export_data.our_json_format_documentation_can_be_found')}
          <a
            href='https://api.acdl.zebra.com/export-json-format.html'
            target='blank'
          >
            {` ${t('here')}`}
          </a>
          .
        </p>
      </div>
    </div>
  );
});
